<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show" color="#FFFF99">
                <v-card-title>
                    <v-row justify="center" align="center">
                        <v-col cols="10" class="text-center">
                            REGISTRO DE REQUISITOS LEGALES
                        </v-col>
                        <v-col cols="2" class="text-center">
                            EI 303
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-card-text class="pt-2">
                    <v-row justify="center" align="center">
                        <v-col cols="10" class="text-center">
                            <h6> {{ tituloaspecto }}{{ tituloalcance }} </h6>
                        </v-col>
                        <v-col cols="2" class="text-center">
                            Rev. Doc. {{ revision }}
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-data-table dense :headers="headers" :items="listado" group-by="tipo" locale="es-ar" class="elevation-1"
                :items-per-page="400" hide-default-footer :loading="loadtable"
                loading-text="Cargando... Espere por favor" no-data-text="No hay datos disponibles">
                <template v-slot:group.header="{ items }">
                    <td :colspan="headers.length" class="text-xs-right" style="color: green;">
                        <strong>{{ items[0].tipo }}</strong>
                    </td>
                </template>
            </v-data-table>
        </v-app>
    </div>
</template>
<style scoped>
.font-class-name2 {
    font-size: 12px !important;
}

::v-deep .v-data-table .v-data-table__wrapper td {
    font-size: 12px !important;
    padding: 2px 4px !important;
}

::v-deep .v-data-table .v-data-table-header tr th {
    font-size: 12px !important;
    padding: 2px 4px !important;
}
</style>
<script>
import axios from "../../../axios-auth.js";
// import VerInforme from "../Requisitos/Informe.vue";
export default {
    data: (vm) => ({
        editedItem: {},
        editedIndex: -1,
        listado: [],
        tituloalcance: "",
        tituloaspecto: "",
        tipoalcance: "",
        tipoaspecto: "",
        revision: "",
        loadtable: false,
        headers: [
            { text: "Tipo", align: "center", sortable: false, value: "tipo", width: "10%" },
            { text: "Código", align: "center", sortable: false, value: "codigo" },
            { text: "Norma", value: "norma", sortable: false },
            { text: "Organismo Emisor", value: "emisor", sortable: false },
            { text: "Descripción", value: "descr", align: "center", sortable: false },
            { text: "A/R", value: "ar", align: "center", sortable: false },
            { text: "Autoridad de Aplicación", value: "autoridad", align: "center", sortable: false },
            { text: "Observaciones", value: "observ", align: "center", sortable: false },
            { text: "Obligaciones", value: "oblig", sortable: false },
            { text: "Aspecto Ambiental", value: "aspectoamb", align: "center", sortable: false },
            { text: "Estado", value: "estado", align: "center", sortable: false },
        ],
    }),
    beforeMount() {
        this.aspecto = this.$route.query.aspecto;
        this.alcance = this.$route.query.alcance;
        if (this.aspecto == "M") {
            this.tituloaspecto = "Medioambientales - ";
            this.tipoaspecto = ""
        }
        if (this.aspecto == "S") {
            this.tituloaspecto = "SST - ";
            this.tipoaspecto = " SST";
        }
        if (this.alcance == "M") {
            this.tituloalcance = "Municipalidad de Córdoba";
            this.tipoalcance = "M";
        }
        if (this.alcance == "P") {
            this.tituloalcance = "Provincia de Córdoba";
            this.tipoalcance = "P";
        }
        if (this.alcance == "N") {
            this.tituloalcance = "Nacionales";
            this.tipoalcance = "N";
        }
        if (this.alcance == "C") {
            this.tituloalcance = "Ciudad Autónoma de Buenos Aires";
            this.tipoalcance = "CABA";
        }
        this.cargarListado();
        this.cargarrevision();

        return this.visible;
    },
    computed: {
        show: {
            get() {
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },

    methods: {

        cargarListado() {
            this.loadtable = true;
            const estado = "";
            const alcance = this.alcance;
            const aspecto = this.aspecto;
            const aspectoamb = "";
            const obligacion = "";
            const descr = "";
            const norma = "";
            const tipo = "";
            const ar = "";

            let self = this;
            axios
                .get("/Sgi/ListadoRequisitos?", {
                    params: {
                        estado: estado,
                        obligacion: obligacion,
                        norma: norma,
                        tipo: tipo,
                        descr: descr,
                        alcance: alcance,
                        aspecto: aspecto,
                        aspectoamb: aspectoamb,
                        ar: ar,
                    },
                })
                .then((response) => {
                    self.listado = response.data;
                    self.loadtable = false;
                    console.log(self.listado)
                })
                .catch((error) => {
                    self.listado = [];
                    console.log(error);
                });
        },

        cargarrevision() {

            const tipo = "EI 303-" + this.tipoalcance + this.tipoaspecto;
            let self = this;
            axios
                .get("/Sgi/RevisionEI303?", {
                    params: {
                        tipo: tipo,
                    },
                })
                .then((response) => {
                    self.revision = response.data;
                    console.log(self.listado)
                })
                .catch((error) => {
                    self.revision = "";
                    console.log(error);
                });
        },
    },
};
</script>